var _circle, _circle2, _g, _circle3, _circle4, _circle5, _g2, _circle6, _circle7, _circle8, _g3, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 76,
    viewBox: "0 0 140 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 38,
    r: 30,
    fill: "#212932"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8173_83288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 60,
    height: 60
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 38,
    r: 30,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8173_83288)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0005,
    cy: 60.8001,
    rx: 22.8,
    ry: 13.2,
    fill: "#4F5B68"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0003,
    cy: 33.5002,
    r: 10.8,
    fill: "#4F5B68"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 38,
    r: 30,
    fill: "#303943"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8173_83288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 8,
    width: 60,
    height: 60
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 38,
    r: 30,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8173_83288)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.0001,
    cy: 60.8001,
    rx: 22.8,
    ry: 13.2,
    fill: "#212932"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9999,
    cy: 33.5002,
    r: 10.8,
    fill: "#212932"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 38,
    r: 30,
    fill: "#212932"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8173_83288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 8,
    width: 60,
    height: 60
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 38,
    r: 30,
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8173_83288)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 60.8001,
    rx: 22.8,
    ry: 13.2,
    fill: "#4F5B68"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 33.5002,
    r: 10.8,
    fill: "#4F5B68"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyState);
export default __webpack_public_path__ + "static/media/icon-empty-state.8b5624a1368eb8076410d98a05f5ebf8.svg";
export { ForwardRef as ReactComponent };